/* assets/nb-wa.js — WhatsApp enquiry prompts (see snippets/nb-wa.liquid).
 *
 *  1. Keeps cart-listing links ([data-nb-wa-cart]) in step with the cart, so
 *     the pre-filled message always lists what is in it right now.
 *  2. Reports every WhatsApp click as a "whatsapp_click" event (Shopify
 *     customer events, plus GA4 / GTM when present) with the prompt's ref.
 *  3. Flags visitors whose browser time zone is not Singapore's
 *     (html.nb-intl) and reveals [data-nb-wa-geo] elements for them. There
 *     is only a Singapore market, so Shopify can't tell us the country; the
 *     time zone is a free, private and good-enough hint.
 */
(function () {
  'use strict';

  function money(cents, currency) {
    return (currency ? currency + ' ' : '') + (cents / 100).toFixed(2);
  }

  function cartMessage(el, cart) {
    var text = el.getAttribute('data-nb-wa-intro') || '';
    var items = (cart && cart.items || []).filter(function (i) { return i && i.quantity > 0; });
    if (items.length) {
      text += '\nItems:';
      items.forEach(function (i) { text += '\n• ' + i.title + ' × ' + i.quantity; });
      text += '\nCart total: ' + money(cart.total_price, cart.currency);
    }
    return text + '\n' + (el.getAttribute('data-nb-wa-outro') || '');
  }

  function syncCartLinks(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-nb-wa-cart]').forEach(function (el) {
      el.href = 'https://wa.me/' + el.getAttribute('data-nb-wa-number') +
        '?text=' + encodeURIComponent(cartMessage(el, cart));
    });
  }

  document.addEventListener('niimbot:cart:updated', function (e) {
    syncCartLinks(e.detail && e.detail.cart);
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-nb-wa]');
    if (!a) return;
    var detail = {
      ref: a.getAttribute('data-nb-wa-ref') || '',
      context: a.getAttribute('data-nb-wa-ctx') || '',
      page: location.pathname
    };
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('whatsapp_click', detail);
      }
    } catch (err) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'whatsapp_click', { wa_ref: detail.ref, wa_context: detail.context });
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'whatsapp_click', wa_ref: detail.ref, wa_context: detail.context });
      }
    } catch (err) {}
    document.dispatchEvent(new CustomEvent('niimbot:whatsapp:click', { detail: detail }));
  });

  function outsideSingapore() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return !!tz && tz !== 'Asia/Singapore';
    } catch (err) {
      return false;
    }
  }

  function isDismissed(key) {
    try { return !!key && localStorage.getItem(key) === '1'; } catch (err) { return false; }
  }

  function initGeo() {
    if (!outsideSingapore()) return;
    document.documentElement.classList.add('nb-intl');
    document.querySelectorAll('[data-nb-wa-geo]').forEach(function (el) {
      var key = el.getAttribute('data-nb-wa-dismiss-key');
      if (isDismissed(key)) return;
      el.hidden = false;
      var close = el.querySelector('[data-nb-wa-dismiss]');
      if (close) {
        close.addEventListener('click', function () {
          el.hidden = true;
          try { if (key) localStorage.setItem(key, '1'); } catch (err) {}
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGeo);
  } else {
    initGeo();
  }
})();
